import { IconCurrencyEuro, IconSitemap } from '@tabler/icons';

// constant
const icons = {
    IconSitemap,
    IconCurrencyEuro
};

// ==============================|| LOTTO ||============================== //

const interventionPlan = {
    id: 'interventionPlan',
    type: 'group',
    title: 'UPDATE_PLANS_LOTTI',
    children: [
        {
            id: 'interventionPlan',
            title: 'INTERVENTION_PLANS',
            type: 'item',
            url: '/intervention-plans',
            icon: icons.IconSitemap,
            breadcrumbs: false
        },
        {
            id: 'price-lists',
            title: 'PRICE_LISTS',
            type: 'item',
            url: '/price-lists',
            icon: icons.IconCurrencyEuro,
            breadcrumbs: false
        }
    ]
};

export default interventionPlan;
